(function() {
	const minutes = 1;

	let now = +(new Date());
	let later = now + (1000 * 60 * minutes);
	let nextAnim = localStorage["anim"];

	if(nextAnim && now < nextAnim) {
		document.body.classList.add("skip-anim");
	}
	else {
		localStorage["anim"] = later;
	}
})();
